<template>
  <div id="totalBox">
    <div class="introduceBox">
      <div class="introduceContent">
        <p class="plateTitle">平台概述</p>
        <div class="plateContent">
                  基于SAAS服务模式的“任马停”中国智慧停车服务平台是停车场运营的核心。我们通过O2O、B2B、B2C、B2G（Government）、PPP模
                  式、产权并购模式、分时租赁等运营模式与各类停车场和车位业主合作，并为每一个场库设计专属的运营改造方案。
        </div>
        <div class="plateContent">
                  大数据的积累，为充电桩充电站、停车场等配套设施的合理规划建设，使配套设施与城市发展相匹配；
        </div>
        <div class="plateContent">
                  为停车场、汽车服务商、商超等服务主体分析车主的需求和习惯，推出针对性的增值服务提供依据与支撑！
        </div>
      </div>
      <img src="../../assets/plan/plan.png" class="plateIcon"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plateintroduce',
  data: function () {
    return {
      msg: '41'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 500px;
  background-color: RGBA(255,255,255, 1);
}
.introduceBox{
  width: 1200px;
  height: 500px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  padding-top: 66px;
}
.introduceContent{
  width: 450px;
  height: 100%;
  padding-top: 60px;
}
.plateIcon{
  width: 772px;
  height: 353px;
  margin-left: 37px;
}
.plateTitle{
  font-size:30px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  line-height:36px;
  text-align: left;
}
.plateContent{
  font-size:14px;
  font-weight:400;
  color:rgba(117,117,117,1);
  line-height:30px;
  text-align: left;
  margin-top: 15px;
}
.plateContent:first-of-type{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/plan/plateintroduce.vue